import api from "./axios";

export const fetchEmployees = async (page = 1, search = "", designation = "", per_page = 15) => {
  return api.get(`/employees`, {
    params: { page, per_page, search: search || undefined, designation: designation || undefined },
  });
};

// Page adapter for AsyncAutocomplete: (page, search) => { items, hasMore }
export const fetchEmployeePage = async (page, search) => {
  const res = await fetchEmployees(page, search || "");
  const paginator = res.data ?? {};
  return {
    items: Array.isArray(paginator.data) ? paginator.data : [],
    hasMore: (paginator.current_page ?? page) < (paginator.last_page ?? 1),
  };
};
export const exportEmployees = async (search = "", designation = "") => {
  return api.get(`/employees`, {
    params: { search: search || undefined, designation: designation || undefined, export: true },
    responseType: 'blob',
  });
};
export const fetchEmployeeById = async (id) => {
  return api.get(`/employees/${id}`);
};
export const createEmployee = async (employeeData) => {
  return api.post("/employees", employeeData);
};
export const updateEmployee = async (id, employeeData) => {
  return api.put(`/employees/${id}`, employeeData);
};
export const fetchEmployeesByDesignation = async (designation) => {
  return api.get(`/employees/by-designation/${designation}`);
};
export const uploadEmployeePhoto = async (id, file) => {
  const formData = new FormData();
  formData.append("photo", file);
  return api.post(`/employees/${id}/photo`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
export const removeEmployeePhoto = async (id) => {
  return api.delete(`/employees/${id}/photo`);
};
export const deleteEmployee = async (id) => {
  return api.delete(`/employees/${id}`);
};
